import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/list-duck";
import { IDocumentCategory } from "interfaces/document-category";

const { Types, Creators } = createActions(
  {
    request: ["query", "onSuccess"],
    success: ["data"],
    failure: ["error"],
    reset: [],
  },
  { prefix: "LIST_DOCUMENT_CATEGORY_" }
);

export interface ListDocumentCategoryState extends IState {
  data: IDocumentCategory[];
}

interface ISuccessListUnitsAction extends ISuccessAction {
  data: IDocumentCategory[];
}

const INITIAL_STATE: ListDocumentCategoryState = {
  data: [],
  loading: false,
  error: null,
};

const request = (state: ListDocumentCategoryState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (
  state: ListDocumentCategoryState,
  action: ISuccessListUnitsAction
) =>
  update(state, {
    data: { $set: action.data },
    loading: { $set: false },
  });

const failure = (state: ListDocumentCategoryState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const listDocumentCategory = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const ListDocumentCategoryTypes = Types;
export const ListDocumentCategoryActions = Creators;
